import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};

const defaultProps = {
  className: ''
};

class ImageFallback extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false
    };

    this.fallBack = this.fallBack.bind(this);
  }

  fallBack() {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <span>{this.props.alt}</span>;
    } else {
      return (
        <img
          className={this.props.className}
          src={this.props.src}
          alt={this.props.alt}
          onError={this.fallBack}
        />
      );
    }
  }
}

ImageFallback.propTypes = propTypes;
ImageFallback.defaultProps = defaultProps;

export default ImageFallback;



// WEBPACK FOOTER //
// ./src/components/common/imageFallback/ImageFallback.jsx